// Prozessfähigkeit je Maß (C+17). Ein Cpk gilt nur für normalverteilte
// Maße und nur in Monte Carlo: σ = T / (6 · Cpk), Mitte = Toleranzmitte
// (zentrierter Prozess angenommen). Ohne Eingabe rechnet die App mit
// Cpk 1,0, also Toleranz = ±3σ.

import { rt, numLocale } from './reportTexts';

export const CPK_MIN = 0.5;
export const CPK_MAX = 3;
export const CPK_SCHNELLWAHL = [1, 1.33, 1.67, 2];

// Gültiger Cpk oder null. Nur echte Zahlen: Strings kommen aus der
// Eingabe bereits geparst (parseNum), aus Dateien gelten sie als ungültig.
export function normCpk(v) {
  return typeof v === 'number' && Number.isFinite(v) && v >= CPK_MIN && v <= CPK_MAX ? v : null;
}

export function wirksamerCpk(el) {
  return normCpk(el?.cpk) ?? 1;
}

export function cpkText(c, lang = 'de') {
  return c.toLocaleString(numLocale(lang), { minimumFractionDigits: 1, maximumFractionDigits: 2 });
}

const VERTEILUNG_KEYS = { normal: 'dist.normal', uniform: 'dist.uniform', triangular: 'dist.triangular' };

// Anzeige für CSV und PDF. Unbekannte oder fehlende Verteilung zählt wie
// im Sampler als Normal.
export function verteilungText(el, lang = 'de') {
  const key = VERTEILUNG_KEYS[el?.distribution] ?? 'dist.normal';
  const name = rt(lang, key);
  if (key !== 'dist.normal') return name;
  const c = wirksamerCpk(el);
  return c === 1 ? name : `${name} (Cpk ${cpkText(c, lang)})`;
}
